var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-menu-click",class:{ 'navigation-menu-click--open': _vm.open },on:{"click":function($event){return _vm.close()}}})}
var staticRenderFns = []

export { render, staticRenderFns }